import { createSlice } from "@reduxjs/toolkit";
import { fetchStockOverview } from "./thunk";

interface StockOverviewState {
  data: any[];
  totalRecords: number;
  loading: boolean;
  error: string | null;
}

const initialState: StockOverviewState = {
  data: [],
  totalRecords: 0,
  loading: false,
  error: null,
};

const stockOverviewSlice = createSlice({
  name: "stockOverview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockOverview.fulfilled, (state, action) => {
        state.loading = false;

        // Your API -> action.payload = { count, data }
        state.data = action.payload.data;
        state.totalRecords = action.payload.totalRecords; // <-- FIXED
      
      })
      .addCase(fetchStockOverview.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch stock overview";
      });
  },
});

export default stockOverviewSlice.reducer;
